(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-build-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
const init=root=>{
 if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const orbit=root.querySelector('[data-pc-orbit]'),slides=[...root.querySelectorAll('[data-pc-slide]')],picker=root.querySelector('[data-pc-picker]'),status=root.querySelector('[data-pc-status]');
 let index=0,startX=0,startY=0,dragging=false,moved=false;
 const render=()=>{slides.forEach((slide,i)=>{let offset=(i-index+slides.length)%slides.length;if(offset>slides.length/2)offset-=slides.length;slide.dataset.offset=String(offset);slide.classList.toggle('is-active',offset===0);slide.hidden=Math.abs(offset)>2;slide.inert=Math.abs(offset)>1;slide.setAttribute('aria-hidden',String(Math.abs(offset)>1));slide.querySelectorAll('a').forEach(a=>a.tabIndex=offset===0?0:-1);if(Math.abs(offset)<=2){const img=slide.querySelector('img');if(img)img.loading='eager';}});picker.value=String(index);status.textContent=(index+1)+' / '+slides.length;};
 const go=n=>{index=(n+slides.length)%slides.length;render();};render();
 picker.addEventListener('change',()=>go(Number(picker.value)));
 orbit.addEventListener('keydown',e=>{if(e.target===picker)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});
 orbit.addEventListener('pointerdown',e=>{if(e.target.closest('select'))return;startX=e.clientX;startY=e.clientY;dragging=true;moved=false;});
 orbit.addEventListener('pointermove',e=>{if(!dragging)return;const dx=e.clientX-startX,dy=e.clientY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.2){moved=true;go(index+(dx<0?1:-1));startX=e.clientX;startY=e.clientY;}});
 const end=()=>{dragging=false;setTimeout(()=>moved=false,200);};window.addEventListener('pointerup',end);orbit.addEventListener('pointercancel',end);orbit.addEventListener('dragstart',e=>e.preventDefault());
 root.addEventListener('click',e=>{const trigger=e.target.closest('[data-pc-open]');if(trigger){e.preventDefault();if(moved)return;const slide=trigger.closest('[data-pc-slide]');if(slide&&!slide.classList.contains('is-active')){go(slides.indexOf(slide));return;}document.getElementById(trigger.dataset.pcOpen)?.showModal();}if(e.target.closest('[data-pc-close]'))e.target.closest('dialog').close();if(e.target.closest('[data-pc-inquire]'))e.target.closest('dialog').close();});
 root.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}));
 root._pcCleanup=()=>window.removeEventListener('pointerup',end);
};
const all=()=>document.querySelectorAll('[data-pc-root]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-pc-root]')));document.addEventListener('shopify:section:unload',e=>e.target.querySelector('[data-pc-root]')?._pcCleanup?.());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-graphic-orbit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const editorSelection = new Map();
  let artworkSerial = 0;
  const sized = (source, width) => {
    const url = new URL(source, document.baseURI);
    url.searchParams.set('width', String(width));
    return url.href;
  };
  const svgNode = (name, attributes) => {
    const node = document.createElementNS('http://www.w3.org/2000/svg', name);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, String(value)));
    return node;
  };
  const visual = (design, label, width = 1200) => {
    if (design.flatGeometry && window.RRFlatBoard?.render && design.images?.board) {
      const host = document.createElement('span');
      host.innerHTML = window.RRFlatBoard.render({
        ...design, images: {...design.images, board: sized(design.images.board, width)}
      }, false, label);
      return host.firstElementChild;
    }
    if (design.artwork) {
      const id = 'rr-graphic-art-' + (++artworkSerial);
      const box = design.artworkBox || [0, 0, 1, 1];
      const svg = svgNode('svg', {viewBox: '-160 -160 4416 4416', role: 'img', 'aria-label': label});
      const defs = svgNode('defs', {});
      const clip = svgNode('clipPath', {id});
      clip.append(svgNode('circle', {cx: 2048, cy: 2048, r: 2048}));
      defs.append(clip);
      svg.append(defs, svgNode('image', {
        href: sized(design.artwork, width), x: -4096 * box[0] / box[2], y: -4096 * box[1] / box[3],
        width: 4096 / box[2], height: 4096 / box[3], preserveAspectRatio: 'none', 'clip-path': 'url(#' + id + ')'
      }), svgNode('circle', {cx: 2048, cy: 2048, r: 2018, fill: 'none', stroke: '#181a1b', 'stroke-width': 60}),
      svgNode('circle', {cx: 2048, cy: 2048, r: 403, fill: '#050607', stroke: '#25282a', 'stroke-width': 65}));
      return svg;
    }
    if (!design.images?.board) return null;
    const image = document.createElement('img');
    image.src = sized(design.images.board, width);
    image.srcset = [360, 540, 750, 1000, width].map(size => sized(design.images.board, size) + ' ' + size + 'w').join(', ');
    image.sizes = '(max-width:445px) 74vw, (max-width:749px) 330px, 480px';
    image.width = image.height = width;
    image.alt = label;
    image.decoding = 'async';
    return image;
  };
  const sameAsset = (first, second) => {
    if (!first || !second) return false;
    const a = new URL(first, document.baseURI), b = new URL(second, document.baseURI);
    return a.origin === b.origin && a.pathname === b.pathname;
  };
  const initialize = root => {
    if (controllers.has(root)) return;
    const viewport = root.querySelector('.rr-graphic-orbit__viewport');
    const slides = [...root.querySelectorAll('[data-rr-orbit-slide]')];
    const counter = root.querySelector('[data-rr-orbit-counter]');
    const popup = root.querySelector('[data-rr-board-dialog]');
    const popupBody = root.querySelector('[data-rr-board-dialog-body]');
    if (!viewport || !slides.length || !popup || !popupBody) return;
    const events = new AbortController();
    const listen = (element, name, callback, options = {}) => element.addEventListener(name, callback, {...options, signal: events.signal});
    const designs = new Map();
    const rendered = new Set();
    let artworkVisible = false;
    let artworkObserver = null;
    let popupOpener = null;
    let current = Math.max(0, slides.findIndex(slide => slide.dataset.rrBlockId === editorSelection.get(root.id)));
    let startX = null;
    let startY = null;
    let suppressClickUntil = 0;
    slides.forEach(slide => {
      try {
        const data = JSON.parse(slide.querySelector('[data-rr-orbit-catalog]')?.textContent || 'null');
        const design = data?.designs?.find(item => item.key === data.initial) || data?.designs?.[0];
        if (design) designs.set(slide, design);
      } catch (_) {}
    });
    const renderVisibleImages = () => {
      if (!artworkVisible) return;
      slides.forEach(slide => {
        if (rendered.has(slide) || Math.abs(Number(slide.dataset.offset)) > 1) return;
        const board = slide.querySelector('[data-rr-board-auto]');
        const design = designs.get(slide);
        if (!board || !design) return;
        try {
          const image = visual(design, slide.getAttribute('aria-label') || '');
          if (image) { board.replaceChildren(image); rendered.add(slide); }
        } catch (_) {}
      });
    };
    const paint = () => {
      slides.forEach((slide, index) => {
        let offset = index - current;
        if (offset > slides.length / 2) offset -= slides.length;
        if (offset < -slides.length / 2) offset += slides.length;
        const active = index === current;
        slide.dataset.offset = String(offset);
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelector('[data-rr-board-open]').tabIndex = active ? 0 : -1;
      });
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      if (window.Shopify?.designMode) editorSelection.set(root.id, slides[current].dataset.rrBlockId);
      renderVisibleImages();
    };
    const select = (index, focus = false) => {
      const focusedSlide = document.activeElement?.closest('[data-rr-orbit-slide]');
      current = (index + slides.length) % slides.length;
      paint();
      if (focus || (focusedSlide && slides.includes(focusedSlide) && focusedSlide !== slides[current])) {
        slides[current].querySelector('[data-rr-board-open]').focus({preventScroll: true});
      }
    };
    const openDetails = (slide, opener) => {
      const content = slide.querySelector('.rr-graphic-orbit__popup-data');
      if (!content || popup.open || typeof popup.showModal !== 'function') return false;
      popupOpener = opener;
      popupBody.replaceChildren(...content.cloneNode(true).childNodes);
      const stage = popupBody.querySelector('[data-rr-popup-auto]');
      const design = designs.get(slide);
      if (stage && design) {
        try {
          if (sameAsset(stage.dataset.rrPopupSource, design.images?.board) || sameAsset(stage.dataset.rrPopupSource, design.artwork)) {
            const image = visual(design, slide.getAttribute('aria-label') || '', 1400);
            if (image) stage.replaceChildren(image);
          }
        } catch (_) {}
      }
      const continueLink = popupBody.querySelector('.rr-graphic-orbit__popup-action a');
      if (continueLink) {
        const destination = new URL(continueLink.href, document.baseURI);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        continueLink.href = destination.pathname + destination.search;
      }
      popup.setAttribute('aria-label', `${slide.getAttribute('aria-label')} — set details`);
      popup.showModal();
      return true;
    };
    listen(root.querySelector('[data-rr-board-close]'), 'click', () => popup.close());
    listen(popup, 'click', event => {
      if (event.target !== popup) return;
      const bounds = popup.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
    });
    listen(popup, 'close', () => popupOpener?.focus({preventScroll: true}));
    listen(viewport, 'touchstart', event => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, {passive: true});
    listen(viewport, 'touchend', event => {
      if (startX === null) return;
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        select(current + (dx < 0 ? 1 : -1));
        suppressClickUntil = Date.now() + 400;
      }
      startX = null;
      startY = null;
    }, {passive: true});
    listen(viewport, 'touchcancel', () => { startX = null; startY = null; }, {passive: true});
    listen(viewport, 'keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      let next;
      if (event.key === 'ArrowRight') next = current + 1;
      else if (event.key === 'ArrowLeft') next = current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = slides.length - 1;
      else return;
      event.preventDefault();
      select(next, Boolean(event.target.closest('[data-rr-board-open]')));
    });
    listen(viewport, 'click', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      const slide = event.target.closest('[data-rr-orbit-slide]');
      if (!slide) return;
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const index = slides.indexOf(slide);
      if (index !== current) {
        event.preventDefault();
        event.stopPropagation();
        select(index);
        return;
      }
      const opener = event.target.closest('[data-rr-board-open]');
      if (opener && openDetails(slide, opener)) event.preventDefault();
    }, {capture: true});
    controllers.set(root, {
      selectBlock(blockId) {
        const index = slides.findIndex(slide => slide.dataset.rrBlockId === blockId);
        if (index < 0) return;
        artworkVisible = true;
        select(index);
      },
      destroy() {
        artworkObserver?.disconnect();
        events.abort();
        if (popup.open) popup.close();
        controllers.delete(root);
        delete root.dataset.rrOrbitReady;
      }
    });
    paint();
    root.dataset.rrOrbitReady = 'true';
    if ('IntersectionObserver' in window) {
      artworkObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        artworkVisible = true;
        renderVisibleImages();
        artworkObserver.disconnect();
      }, {rootMargin: '600px 0px'});
      artworkObserver.observe(root);
    } else {
      artworkVisible = true;
      renderVisibleImages();
    }
  };
  const rootsWithin = scope => scope.matches?.('[data-rr-graphic-orbit]') ? [scope] : [...scope.querySelectorAll('[data-rr-graphic-orbit]')];
  const initializeWithin = scope => rootsWithin(scope).forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), {once: true});
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => rootsWithin(event.target).forEach(root => controllers.get(root)?.destroy()));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-rr-graphic-orbit]');
    if (!root) return;
    initialize(root);
    controllers.get(root)?.selectBlock(event.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-home-shop-edit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const option = event.target.closest('[data-rr-design-option]');
  if (!option) return;
  const card = option.closest('[data-rr-design-card]');
  if (!card) return;
  card.querySelectorAll('[data-rr-design-option]').forEach(function(button) {
    button.setAttribute('aria-pressed', String(button === option));
  });
  const image = card.querySelector('.rr-shop-edit__media img');
  image.removeAttribute('srcset');
  image.src = option.dataset.image;
  image.alt = option.dataset.alt;
  const media = card.querySelector('.rr-shop-edit__media');
  media.href = option.dataset.url;
  media.setAttribute('aria-label', option.dataset.alt);
  card.querySelector('.rr-shop-edit__cta').href = option.dataset.url;
  card.querySelector('.rr-shop-edit__title > span').textContent = option.dataset.price;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-home-value"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rr-board-explorer')) {
  customElements.define('rr-board-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (tabs.length !== panels.length || !tabs.length) return;
      const select = (index, focus = false) => {
        tabs.forEach((tab, n) => { tab.setAttribute('aria-selected', String(n === index)); tab.tabIndex = n === index ? 0 : -1; });
        panels.forEach((panel, n) => { panel.hidden = n !== index; if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause()); });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); select(next, true);
        });
      });
      this.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => { if (!detail.open) detail.querySelectorAll('video').forEach(video => video.pause()); }));
      select(0); this.dataset.ready = 'true'; this.querySelector('[role="tablist"]').hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
